/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".jumbotron[_ngcontent-%COMP%]{box-shadow:5px 7px 20px #605f6b;border-radius:15px;-moz-border-radius:15px;-webkit-border-radius:15px 15px 15px 15px;border:0 solid gray}\n/*# sourceMappingURL=changuepass.component.css.map*/"];
export { styles as styles };
